import { Language } from "@restofrit/structures";

class EditLanguageHelperStatic {
    language: Language = Language.nl
}

export const EditLanguageHelper = new EditLanguageHelperStatic()

export const EditPromotionLanguageHelper = new EditLanguageHelperStatic()